import React from "react";

import Shadow from "assets/images/shadow.png";
import Pad from "assets/images/pad.png";
import Button from "elements/Button";
import Size from "./Size";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

export default function Galeries({ data, size }) {
  const [product, setProduct] = React.useState({});

  React.useEffect(() => {
    if (data) setProduct(data.data);
  }, [data]);

  return (
    <section className="section-galeries">
      <div className="container">
        <div className="row">
          <div className="col-7">
            <div className="text-center">
              {product ? (
                <>
                  <img
                    src={product.image ? product.image[0] : ""}
                    alt=""
                    className="img-product"
                  />
                  <img src={Shadow} alt="Shadow" className="img-shadow" />
                  <img src={Pad} alt="Pad" className="img-pad" />
                </>
              ) : (
                <Button isLoading></Button>
              )}
            </div>
          </div>
          <div className="col-5 align-self-center text-center">
            <OwlCarousel
              className="mb-1"
              stagePadding={"0"}
              merge={true}
              loop={true}
              autoplay={true}
              autoplayTimeout={"2000"}
              responsive={{
                0: {
                  items: 1,
                },
                540: {
                  items: 1,
                },
                960: {
                  items: 2,
                },
                1140: {
                  items: 2,
                },
              }}
            >
              {data ? (
                data.data.image ? (
                  data.data.image.slice(1, 4).map((item, index) => (
                    <div className="card-thumb" key={`image-${index}`}>
                      <div className="card my-1">
                        <Button className="thumb-img">
                          <img className=" img-fluid" src={item} alt="" />
                        </Button>
                      </div>
                    </div>
                  ))
                ) : (
                  "Image Not Found"
                )
              ) : (
                <Button isLoading></Button>
              )}
            </OwlCarousel>

            <Size listSize={size} />
          </div>
        </div>
      </div>
    </section>
  );
}
